import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';

import { contactpersonRoutes } from './contactperson/contactperson.routes';
import { customerRoutes } from './customer/customer.routes';
import { employeeRoutes } from './employee/employee.routes';

export const appRoutes: Routes = [
  ...customerRoutes,
  ...contactpersonRoutes,
  ...employeeRoutes,
  ...coreRoutes,
];
